import { render, staticRenderFns } from "./global-notice.vue?vue&type=template&id=fe5da392"
import script from "./global-notice.vue?vue&type=script&lang=js"
export * from "./global-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports